import parseISO from "date-fns/parseISO";
import formatDate from "@DateTime/functions/formatDate";
import IconSlimArrowRight from "@Icons/IconSlimArrowRight";
import IconFerryOutline from "@Icons/IconFerryOutline";
import React from "react";

interface NextDeparturesRowsProps {
    nextDepartures: any[]
}

function NextDeparturesRows({nextDepartures}: NextDeparturesRowsProps) {
    const keyCounter = {};
    return (
        <>
            {nextDepartures.map((nextDeparture) => {
                const {
                    date,
                    departureTime,
                    searchUrl,
                    toStationName,
                    companyName,
                    vesselName,
                    vesselTypeName,
                } = nextDeparture

                const nextDepartureDateTime = parseISO(`${date} ${departureTime}`);
                let currentKey = `${date}-${departureTime}-${toStationName}`;

                if (!keyCounter.hasOwnProperty(currentKey)) {
                    keyCounter[currentKey] = 0;
                } else {
                    keyCounter[currentKey]++;
                }

                if (keyCounter[currentKey] > 0) {
                    currentKey = `${currentKey}-${keyCounter[currentKey]}`;
                }

                return (
                    <div className="gb--schedule-list gb--row gb--row-wrap" key={currentKey}>
                        <div>
                            {formatDate(nextDepartureDateTime)}
                            &nbsp;
                            |
                            &nbsp;
                            <span>
                                {formatDate(nextDepartureDateTime, 'HH:mm')}
                                &nbsp;
                            </span>
                            <IconSlimArrowRight/>
                            <a
                                href={searchUrl}
                                target="_blank"
                            >
                                &nbsp;
                                {toStationName}
                            </a>
                        </div>
                        <div>
                            <span>
                                {companyName}
                                &nbsp;
                                <IconFerryOutline
                                    style={{verticalAlign: 'sub'}}
                                />
                            </span>
                            {vesselTypeName && (`| ${vesselTypeName}`)}
                            &nbsp;
                            {vesselName && (`| ${vesselName}`)}
                        </div>
                    </div>
                );
            })}
        </>
    )
}

export default NextDeparturesRows